import { Flame, ChevronDown } from 'lucide-react';
import HotNewsFeed from './HotNewsFeed';

export const MobileHotNewsToggle = ({ hotStories, isOpen, onToggle }) => (
  <>
    <button
      onClick={onToggle}
      className="lg:hidden w-full mb-4 flex items-center justify-between p-4 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg shadow-md"
      data-testid="mobile-hot-news-toggle"
    >
      <div className="flex items-center gap-2">
        <Flame className="w-5 h-5" />
        <span className="font-semibold">Hot News</span>
        <span className="text-xs bg-white/20 px-2 py-0.5 rounded-full">{hotStories.length}</span>
      </div>
      <ChevronDown className={`w-5 h-5 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
    </button>

    {isOpen && (
      <div className="lg:hidden mb-6">
        <HotNewsFeed stories={hotStories} isMobile={true} />
      </div>
    )}
  </>
);
